export default {
  title: "Plantillas de Correo"
  , records: "Registros"
  , form: {
    remitente: { label: "Remitente" }
    , descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , multiListPerfilesDestinatarios: { label: "Perfil Destinatario" }
    , destinatariosOpcionales: { label: "Destinatarios Opcionales" }
    , cc: { label: "CC" }
    , cco: { label: "CCO" }
    , asunto: { label: "Asunto" }
    , cuerpo: { label: "Cuerpo" }
    , status: { label: "Estatus" }
  }
  , errors: {
    BD3001: { text: "Ocurrió un error en el catálogo de Plantillas de Correo" }
    , WS3001: { text: "Ocurrió un error en el catálogo de Plantillas de Correo" }
    , JS3001: { text: "Ocurrió un error en el catálogo de Plantillas de Correo" }
    , CR3001: { text: "Ocurrió un error en el catálogo de Plantillas de Correo" }
    , PK3001: { text: "Ya existe un registro con la misma clave" }
    , VH3001: { text: "Esta plantilla de correo ha sido modificada por otro usuario" }
    , VS3001: { text: "Esta plantilla de correo ha sido modificada por otro usuario" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/generales/plantillaCorreo.js